import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SearchforceFindConnectIdEventsComponent } from './find-connect-id-events.component';
import { SelectAccountComponent } from './select-account/select-account.component';
import { FindConnectIdEventsRoutingModule } from './find-connect-id-events.routing.module';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { SearchforceSearchConnectIdComponent } from './search-form/search.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    FindConnectIdEventsRoutingModule
    // RouterModule.forChild(routes)
  ],
  declarations: [
    SearchforceFindConnectIdEventsComponent,
    SearchforceSearchConnectIdComponent,
    SelectAccountComponent
  ],
  bootstrap: [
    SearchforceFindConnectIdEventsComponent,
    SelectAccountComponent
  ]
})
export class SearchforceFindConnectIdEventsModule {}

